import { defineComponent, reactive, ref } from 'vue';
import HttpRequest from '@/util/axios.config';
import { useRouter } from 'vue-router';
export default defineComponent({
    setup() {
        const router = useRouter();
        const userData = reactive({
            Account: '',
            Password: '',
            Email: ''
        });
        const encrypt = ref(true);
        const showNameTips = ref(false);
        const showPasswdTips = ref(false);
        const errorMsg = ref('');
        const emailTips = ref('');
        const checkValid = (type) => {
            if (type === 'name') {
                showNameTips.value = userData.Account === '';
                return showNameTips.value;
            }
            if (type === 'email') {
                const reg = /^[.a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
                if (userData.Email === '') {
                    emailTips.value = 'Please enter the email.';
                }
                else if (!reg.test(userData.Email)) {
                    emailTips.value = 'Please enter a valid email address.';
                }
                else {
                    emailTips.value = '';
                }
                return emailTips.value !== '';
            }
            return true;
        };
        const loginBtnType = ref('normal');
        const groups = ['Admin', 'User'];
        const clearError = () => {
            showPasswdTips.value = false;
            errorMsg.value = '';
        };
        const login = () => {
            if (loginBtnType.value === 'unavailable') {
                return;
            }
            clearError();
            loginBtnType.value = 'normal';
            if (checkValid('name')) {
                return;
            }
            HttpRequest.post('login', {
                Account: userData.Account,
                Password: userData.Password
            }, (res) => {
                localStorage.setItem('token', res.data.authToken);
                localStorage.setItem('userInfo', JSON.stringify({
                    userName: res.data.Nickname,
                    email: res.data.Email,
                    identity: groups[Number(res.data.Group) - 1]
                }));
                router.push('/global');
            }, (err) => {
                errorMsg.value = err.msg;
                showPasswdTips.value = true;
            });
        };
        const isReset = ref(false);
        const beforeReset = ref(true);
        const goToResetPage = () => {
            isReset.value = true;
            beforeReset.value = true;
            userData.Email = '';
            emailTips.value = '';
        };
        const reset = () => {
            if (loginBtnType.value === 'unavailable') {
                return;
            }
            loginBtnType.value = 'normal';
            if (checkValid('email')) {
                return;
            }
            HttpRequest.post('resetPwdEmail', {
                Email: userData.Email
            }, () => {
                beforeReset.value = false;
            }, () => {
                emailTips.value = 'This Email doesn\'t exist.';
            });
        };
        return {
            userData,
            encrypt,
            showNameTips,
            showPasswdTips,
            emailTips,
            checkValid,
            loginBtnType,
            login,
            isReset,
            beforeReset,
            goToResetPage,
            reset,
            errorMsg
        };
    }
});
